import { render, staticRenderFns } from "./Candidatures.vue?vue&type=template&id=bd1f7a76"
import script from "./Candidatures.vue?vue&type=script&lang=js"
export * from "./Candidatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports